import React from 'react'

import { FeatureLanding, FeatureSection, Column, ProdigySlider } from '../../components/landing'
import { LogoRow } from '../../components/landing'
import { CodeBlock } from '../../components/code'
import { Button } from '../../components/link'
import Icon from '../../images/icons/landing-audio.svg'
import socialImage from '../../images/social_audio.jpg'

import uiExamples from './examples-audio.json'

export default () => (
    <FeatureLanding
        title="Audio &amp; Video"
        description="Label audio and video files in-house for tasks such as speaker diarization and classification. Use Prodigy’s fully scriptable back-end to build powerful workflows by putting your model in the loop."
        callToAction="/docs/audio-video"
        blobColor1="#eb8865"
        blobColor2="#5bc0eb"
        socialImage={socialImage}
        icon={Icon}
    >
        <FeatureSection columns={[40, 60]} vcenter={false}>
            <Column title="Fast and flexible annotation " spaced>
                <p>
                    Highlight slices of an audio or video file, and mark them with whatever labels
                    you need. You can zoom in and out to make your annotations more precise, and
                    easily start, stop and replay the input to make sure you get it right. Keyboard
                    shortcuts and scriptable automation make sure you'll fly through the task as
                    quickly as possible. Perfect for tasks like speaker diarization, topic
                    segmentation and disfluency elimination.
                </p>
                <Button to="/docs/audio-video#manual">Read more</Button>
            </Column>
            <Column>
                <ProdigySlider data={uiExamples.slice(0, 2)} showButtons={false} />
            </Column>
        </FeatureSection>

        <FeatureSection columns={[60, 40]} vcenter={false}>
            <Column>
                <ProdigySlider
                    id="slider2"
                    align="left"
                    data={uiExamples.slice(2)}
                    showButtons={false}
                />
            </Column>
            <Column title="Classify, summarize or transcribe" spaced>
                <p>
                    Quickly sort audio or video inputs into custom categories, marking them as
                    relevant or irrelevant, or grouping them for further analysis. Add one or more
                    text boxes to transcribe audio or summarize scenes, with simple server-side
                    validation to make sure your data meets whatever consistency and quality
                    standards you require.
                </p>

                <Button to="/docs/audio-video#transcribe">Read more</Button>
            </Column>
        </FeatureSection>

        <FeatureSection>
            <Column title="Plug in your own models">
                <p>
                    Custom recipes let you integrate machine learning models using{' '}
                    <strong>any framework of your choice</strong>, load in data from different
                    sources, implement your own storage solution or add other hooks and features. No
                    matter how complex your pipeline is – if you can call it from a Python function,
                    you can use it in Prodigy.
                </p>

                <LogoRow
                    logos={[
                        { name: 'pytorch', url: 'https://pytorch.org', width: 110 },
                        { name: 'tensorflow', url: 'https://www.tensorflow.org', width: 140 },
                    ]}
                />

                <Button to="/docs/audio-video#model">View examples</Button>
            </Column>
            <Column>
                <CodeBlock title="recipe.py" lang="python">
                    {`@prodigy.recipe("custom-audio-recipe")
def custom_audio_recipe(dataset, data_dir):
    stream = Audio(data_dir)
    model = load_your_model()
    return {
        "dataset": dataset,
        "stream": model(stream),
        "update": model.update,
        "view_id": "audio_manual"
    }`}
                </CodeBlock>
            </Column>
        </FeatureSection>
    </FeatureLanding>
)
